import React from "react";
import Chart from "react-apexcharts";

const SparklineChart3 = ({ data }) => {
  let highestLikelihood = 0;
  data.forEach((item) => {
    if (item.likelihood > highestLikelihood) {
      highestLikelihood = item.likelihood;
    }
  });
  const sparklineData = [1, 2, 3, 3, 4, 3, 4, 4, 4, 3, 1, 2, 1];
  const labels = ['Likelihoods'];
  const spark1 = {
    chart: {
      id: "sparkline1",
      group: "sparklines1",
      type: "area",
      height: 160,
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      curve: "straight",
    },
    fill: {
      opacity: 1,
    },
    series: [
      {
        name: 'Highest Likelihood',
        data: sparklineData,
      },
    ],
    labels,
    xaxis: {
      type: "category",
    },
    yaxis: {
      min: 0,
    },
    colors: ["#fff"],
    title: {
      text: "Likelihood",
      offsetX: 30,
      style: {
        fontSize: "24px",
        color: "#fff",
        cssClass: "apexcharts-yaxis-title",
      },
    },
    subtitle: {
      text: ` ${highestLikelihood}`,
      offsetX: 30,
      style: {
        fontSize: "14px",
        color: "#fff",
        cssClass: "apexcharts-yaxis-title",
      },
    },
  };
  return (
    <div>
      <Chart
        options={spark1}
        series={spark1.series}
        type="area"
        width={"100%"}
        height={97}
      />
    </div>
  );
};

export default SparklineChart3;
